import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { createManifestValidationForm } from "../../utils/validationSchemas";
import ComboboxInput from "../Reusable/ComboboxInput";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import MultipleSelectField from "../Reusable/MultipleSelectField";
import { postApiData } from "../../helpers/AxiosInstance";
import { useEffect, useState } from "react";

const CreateManifest = (props: any) => {
  const { handleCreate, isLoading, data } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createManifestValidationForm),
    defaultValues: async () => {
      return {
        destination_branch: data?.[0],
      };
    },
  });

  const [previousCities, setPreviousCities] = useState([]);

  const destinationBranch = watch("destination_branch");
  const handleGetAllowedCity = async (value: any) => {
    const url = `${APIS.MANIFEST}last-allowed-cities/`;
    const formData = {
      destination_branch: value?.id ?? value,
    };
    try {
      const res = await postApiData({ url, formData, setError });
      if (res?.status === 200) {
        setPreviousCities(res?.data?.allowed_cities);
        setValue(
          "allowed_cities",
          res?.data?.allowed_cities?.map((item: any) => ({
            label: item?.name,
            value: item?.id,
          }))
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (destinationBranch) {
      handleGetAllowedCity(destinationBranch);
    }
  }, [destinationBranch]);

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Submit"}
        isLoading={isLoading}
      >
        <div className={tw`mx-4`}>
          <div className={tw`grid grid-cols-2 gap-x-4 `}>
            <ComboboxInput
              url={APIS.BRANCH}
              queryKey={"branch"}
              register={register("destination_branch")}
              errors={errors?.destination_branch}
              name={"destination_branch"}
              label={"Destination"}
              props={{
                is_active: true,
              }}
              setValue={setValue}
              placeholder={"Search branch"}
              getValues={getValues}
              clearErrors={clearErrors}
            />
            <MultipleSelectField
              label={"Allowed Cities"}
              queryKey={"allowed-city"}
              register={register("allowed_cities")}
              watch={watch}
              setValue={setValue}
              url={`${APIS.LOCATION}flat-location/`}
              errors={errors.allowed_cities}
              value={
                Array.isArray(previousCities) && previousCities?.length > 0
                  ? previousCities?.map((item: any) => ({
                      label: item?.name,
                      value: item?.id,
                    }))
                  : []
              }
              props={{
                level: 3,
                is_active: true,
              }}
            />
          </div>
          <div>
            <TextField
              label={"Note"}
              register={register(`note`)}
              errors={errors?.note}
            />
          </div>
        </div>
      </FormLayout>
    </>
  );
};

export default CreateManifest;
